var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.207 3.293a1 1 0 0 1 0 1.414L6 13.914 1.293 9.207a1 1 0 0 1 1.414-1.414L6 11.086l7.793-7.793a1 1 0 0 1 1.414 0z","fill":"#fff"}));
}

Checkmark.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
